<template>
  <v-dialog :value="value" @input="close" max-width="600px">
    <v-card>

      <!-- Title -->
      <v-card-title>
        <h3 v-if="item">{{$t('settings.fm-accounts.mainDialog.edit.title')}}</h3>
        <h3 v-else>{{$t('settings.fm-accounts.mainDialog.add.title')}}</h3>
      </v-card-title>

      <v-card-text>
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-row>

            <!-- Firstname -->
            <v-col cols="12" md="6" class="mt-12">
              <v-text-field
                  outlined
                  :rules="requiredRules"
                  :label="$t('settings.fm-accounts.labels.person.firstname')"
                  maxlength="100"
                  v-model="form.person.firstname" />
            </v-col>

            <!-- Name -->
            <v-col cols="12" md="6" class="mt-md-12">
              <v-text-field
                  outlined
                  :rules="requiredRules"
                  :label="$t('settings.fm-accounts.labels.person.name')"
                  maxlength="100"
                  v-model="form.person.name" />
            </v-col>

            <!-- Position -->
            <v-col cols="12" class="mt-2">
              <v-text-field
                  outlined
                  :label="$t('settings.fm-accounts.labels.position')"
                  maxlength="100"
                  v-model="form.position" />
            </v-col>

            <!-- Email -->
            <v-col cols="12" class="mt-2">
              <v-text-field
                  outlined
                  :rules="requiredRules"
                  :label="$t('settings.fm-accounts.labels.user.email')"
                  v-model="form.user.email" />
            </v-col>

            <!-- Role -->
            <v-col cols="12" class="mt-2">
              <v-select
                :items="$t('constants.membersRoles.list')"
                :label="$t('settings.fm-accounts.labels.user.role')"
                v-model="form.user.role"
                outlined />
            </v-col>

            <!-- Password only if create -->
            <v-col cols="12" class="mt-2">
              <v-text-field
                  :type="showPassword ? 'text' : 'password'"
                  :append-icon="showPassword ? 'far fa-eye-slash' : 'far fa-eye'"
                  @click:append="showPassword = !showPassword"
                  :rules="requiredRules"
                  :label="$t('settings.fm-accounts.labels.user.password')"
                  v-model="form.user.password"
                  outlined>
                <v-tooltip
                    slot="append-outer"
                    bottom>
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on">fas fa-question-circle</v-icon>
                  </template>
                  <template v-for="(policy) in $t('profile.password.tooltips.password_rules')">
                    <div :key="policy"> - {{policy}}</div>
                  </template>
                </v-tooltip>
              </v-text-field>
            </v-col>

            <!-- Enabled -->
            <v-col cols="12" class="mt-2">
              <v-switch
                  outlined
                  :rules="requiredRules"
                  :label="$t('settings.fm-accounts.labels.user.enabled')"
                  v-model="form.user.enabled" />
            </v-col>

            <v-col cols="12">
              <AlertBar />
            </v-col>

          </v-row>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <ButtonBarFormDialog
            class="mx-3"
            :is-loading-btn-save="isLoadingBtn.btnSave"
            @submit="customSubmit"
            @cancel="close" />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import dialogMixin from "@/mixins/dialog"
import formRules from "@/mixins/formRules";

export default {
  name: "MemberMainDialog",

  mixins: [dialogMixin, formRules],

  components: {
    AlertBar: () => import("@/components/Common/Bars/AlertBar"),
    ButtonBarFormDialog: () => import("@/components/Common/Buttons/ButtonBarFormDialog"),
  },

  data() {
    return {
      isLoadingBtn: {btnSave: false},
      showPassword: false,
      defaultForm: {
        person: {
          firstname: "",
          name: ""
        },
        user: {
          role: "ANALYST"
        }
      }
    }
  },

  methods: {
    customSubmit() {
      if (this.$refs.form.validate()) {
        this.isLoadingBtn.btnSave = true;

        if (this.item)
          this.submitEdit();
        else
          this.submitAdd();
      }
    },

    submitAdd() {
      this.$http.post(`/fm-accounts`, this.form, {
            headers: {Authorization: "Bearer " + this.$session.get('jwt')}
          })
          .then(res => {
            this.$store.commit("toast/showSuccess", this.$t('settings.fm-accounts.mainDialog.add.success'));
            this.close(true);
          })
          .catch(err => {
            this.$store.commit("alert/showErrorAxios", err);
          })
          .finally(() => {
            this.isLoadingBtn.btnSave = false;
          });
    },


    submitEdit() {

      this.$http
          .put(`/fm-accounts/${this.item.id}`, this.form, {
            headers: {Authorization: "Bearer " + this.$session.get('jwt')}
          })
          .then(res => {
            this.$store.commit("toast/showSuccess", this.$t('settings.fm-accounts.mainDialog.edit.success'));
            this.close(true);
          })
          .catch(err => {
            this.$store.commit("alert/showErrorAxios", err);
          })
          .finally(() => {
            this.isLoadingBtn.btnSave = false;
          });
    }

  }
}
</script>

<style scoped>

</style>
